<!--    The Button that represents a Device / CompoundMeter in the Device List 
        In The Case of CompoundMeters it only displays The Data of the main Watermeter in that configuration    -->
<!--Copy right - © 2024 tecera gmbh-->


<script>
    import {
        selected_device,
        toast_message,
        all_devices
    } from "../../stores.js";
    import {
        remove_device_from_customer
    } from "../../scripts/data.js";

    async function remove_customer(device_id) {
        const message = await remove_device_from_customer(device_id);
        $toast_message = message;
        $all_devices = $all_devices.filter((device) => device.id !== device_id);
    }

    export let device;
    let show_delete_icon = false;
</script>

<div class="row hovering" on:mouseenter={() => {show_delete_icon = true}}
    on:mouseleave={() => {show_delete_icon = false}}>
    <div class="col-10 pr-0">
        <button
            on:click={() => {
                if ($selected_device != device) {
                    $selected_device = device;
                } 
            }}
            type="button"
            class="btn btn-normal btn-transparent btn-block bold text-left"
            style="padding-top: 0.6875rem; padding-bottom: 0.6875rem;"
        >
        {#if !device.sub_id}
            {device.dev_eui}
        {:else}
            {device.dev_eui} - {device.sub_id}
        {/if}
        </button>
    </div>
    <div class="col-2 white pl-0">
        {#if show_delete_icon}
        <button
            type="button"
            class="btn btn-normal btn-transparent btn-block"
            style="padding-top: 0.6875rem; padding-bottom: 0.6875rem;"
            on:click={() => remove_customer(device.id)}
        >
            

                <i class="fa fa-trash-can"></i>
            </button>
            {/if}
    </div>
</div>